<div *ngIf="!ability.isSSO || !ability.mainLabUrl" class="flex flex-col h-full shadow-[0px_0px_15px_0px_#0000001F]">
  <!-- Navigation Links -->
  <nav class="flex-1">
    <ng-container *ngFor="let link of links">
      <a
        [routerLink]="link.link"
        [class.active-link]="isActiveLink(link)"
        [ngClass]="{
          'bg-primary': isActiveLink(link),
          'text-white': isActiveLink(link)
        }"
        *ngIf="ability.canView(link.ability) && !link.hideForRoles?.includes(ability.role) && (link.showOnlyForRoles?.includes(ability.role) ?? true)"
        class="flex flex-col justify-center gap-y-2.5 text-[13px] items-center h-[100px] w-[100px] overflow-hidden rounded-control border border-solid border-transparent hover:border-primary no-underline text-primary visited:text-primary active-link:text-white"
      >
        <mat-icon class="sidebar-icon" fontSet="material-symbols-outlined">{{
          link.icon
        }}</mat-icon>
        <span class="block w-full px-1 text-center leading-tight break-words">{{ link.title | titlecase }}</span>
      </a>
    </ng-container>
  </nav>
  <img src="/assets/images/logo-shape.svg" />
</div>
